import styled from "styled-components";

import { Grid } from "@mui/material";
import BannerImg from "../../assets/cangoo-politica-banner.jpg"

export const BannerGrid = styled(Grid)`
background: url(${BannerImg});
background-repeat: no-repeat;
background-position: top center; 
background-size: cover; 

padding-bottom: 10rem;
padding-top: 24rem;

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.title {
    position: relative;
    width: fit-content;
    display: flex;
 
    margin-left: 10rem;
    animation: fadeIn 2s ease-in-out;


    h1 {
        font-family: 'Nexa-Black'; 
        font-size: 8rem;
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
        padding-right: 4rem;
        padding-bottom: 4rem;

        line-height: 10rem;
    }

    img {
        width: 15rem;
        position: absolute;
        right: 0;
        bottom: 0;
      
    }
}


@media (max-width: 1400px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {

    h1 { 
        font-size: 5rem;
        padding-right: 3rem;
        padding-bottom: 3rem;

        line-height: 6rem;
    }

    img {
        width: 10rem;  
        bottom: 0;
    }
   }
  }
 
  @media (max-width: 900px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {
    margin-left: auto;
    margin-right: auto;    

    h1 { 
        font-size: 4rem;
        padding-right: 3rem;
        padding-bottom: 2rem;

        line-height: 6rem;
    }

    img {
        width: 8rem;  
    }
   }
  }
`;



export const PoliticaGrid = styled(Grid)`
padding: 6rem 20rem;
animation: fadeIn 1s ease-in-out;


h1 {
  color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  font-family: 'Nexa-Bold'; 
  font-size: 5rem;
  font-size: clamp(2.4rem, 3.4vw, 4rem); 
  margin-bottom: 2rem;
  text-align: center;
}

p {
  font-family: 'Mont-Light'; 
  font-size: clamp(1.6rem, 3.4vw, 2.8rem); 
  letter-spacing: 1.5px;
  margin-bottom: 6rem;
  color: ${({ theme }) => theme.COLORS.BLUE};
}

@media (max-width: 1400px) {
    padding: 6rem 12rem;

    h1 {
      font-size: clamp(2.4rem, 3.4vw, 3.2rem); 

    }

    p {
      font-size: clamp(1.6rem, 3.4vw, 2.2rem); 
    }
}

@media (max-width: 900px) {
    padding: 6rem 2rem;
    text-align: center;
}
`;


